module.exports = __webpack_public_path__ + "media/images/lb/015-5eadf3693a2b0eea5bc07dc0e8d48328.svg";